export const SET_LOADING = 'SET_LOADING';

export enum ELoadingType {
  NONE = 'none',
  SPINNER = 'spinner',
  OPENING_IMAGE = 'openingImage',
}

export interface ILoadingAction {
  type: string;
  loading: ELoadingType;
}

export interface ILoadingState {
  loading: ELoadingType;
}
